import { styled } from "simplydo/react/styled";

import type { UISize } from "../utils/UIContext";
import { SIZE_FONT } from "../utils/colors";

const popupFontSize = (size?: UISize): string =>
  size === "small"
    ? SIZE_FONT.small
    : size === "large"
      ? SIZE_FONT.large
      : "0.875em";

export const PopupSurface = styled.div<{
  $transparent?: boolean;
  $wide?: boolean | "very";
  $inverted?: boolean;
  $size?: UISize;
  $fluid?: boolean;
}>`
  display: block;
  z-index: 1900;
  position: absolute;
  width: fit-content;
  max-width: ${({ $fluid, $wide, $transparent }) => {
    if ($fluid || $transparent) {
      return "none";
    }
    if ($wide === "very") {
      return "450px";
    }
    if ($wide) {
      return "300px";
    }
    return "200px";
  }};
  min-width: min-content;
  font-size: ${({ $size }) => popupFontSize($size)};
  line-height: 1.2rem;
  color: ${({ $inverted }) =>
    $inverted ? "rgba(255, 255, 255, 0.9)" : "rgba(0, 0, 0, 0.87)"};
  word-wrap: break-word;

  border-radius: 0.3rem;
  padding: ${({ $transparent }) => ($transparent ? "0" : "0.833em 1em")};
  box-shadow: ${({ $transparent }) =>
    $transparent
      ? "none"
      : "0 2px 4px 0 rgba(34, 36, 38, 0.12), 0 2px 10px 0 rgba(34, 36, 38, 0.15)"};
  border: ${({ $transparent, $inverted }) => {
    if ($transparent || $inverted) {
      return "none";
    }
    return "1px solid #d4d4d5";
  }};
  background: ${({ $transparent, $inverted }) =>
    $transparent ? "transparent" : $inverted ? "#1b1c1d" : "#ffffff"};
`;

export const PopupContentEl = styled.div`
  /* content wrapper */
`;
